// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import FormTicket from "components/FormTicket";
// reactor
import Page from "components/Page";
// custom
import TicketsList from "components/TicketsList";
import { updateURLParameter } from "helpers";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class WrapperTicketPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    tickets: PropTypes.array,
    createTicket: PropTypes.func,
    deleteTicket: PropTypes.func,
    updateTicket: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedTicket: undefined,
      formTicketOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { tickets } = this.props;

    switch (index) {
      case 0:
        return (
          <TicketsList
            tickets={tickets}
            onSelect={(selectedTicket) =>
              this.setState({
                selectedTicket,
                formTicketOpen: true,
              })
            }
          />
        );
      default:
    }

    return [];
  }

  render() {
    const {
      classes,
      history,
      loading,
      createTicket,
      deleteTicket,
      updateTicket,
      refresh,
    } = this.props;

    const { index, selectedTicket, formTicketOpen } = this.state;

    return (
      <Page
        helmet="Tickets"
        loading={loading}
        // fab={(
        //   <Button
        //     variant="fab"
        //     color="primary"
        //     aria-label="Add"
        //     onClick={() => this.setState({ formTicketOpen: true })}
        //   >
        //     <AddIcon />
        //   </Button>
        // )}
        loadingMessage={"Fetching all Tickets"}
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push({
                search: updateURLParameter("index", v),
              });
            }}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="All"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormTicket
          open={formTicketOpen}
          ticket={selectedTicket}
          close={() => {
            this.setState({
              formTicketOpen: false,
            });
            setTimeout(
              () =>
                this.setState({
                  selectedTicket: undefined,
                }),
              200
            );
          }}
          createTicket={createTicket}
          deleteTicket={deleteTicket}
          updateTicket={updateTicket}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperTicketPage);
